<template>
    <div>
        <TheHeader class="pc-header" />
        <BaseTitle :infor="infor" />
        <BaseListUlmoudle1
            class="industry-experience-list-ul"
             :list="serviceList"
        />
        <TheFooter class="pc-the-footer-other" />
    </div>
</template>

<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseListUlmoudle1 from '@/components/module/BaseListUlmoudle1'

    import '@/assets/less/module/module-industry-experience-list_industry-experience-list-ul.less'

    export default {
        name: 'PCIndustryExperience',
        props: {
            json: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseListUlmoudle1
        },
        data: function(){
            return {}
        },
        computed: {
            infor: function(){
                let infor = this.json.infor;
                return infor;
            },
            serviceList: function(){
                let serviceList = this.json.serviceList;
                return serviceList;
            }   
        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>